import React, { useState, useEffect, useRef } from 'react';
import './Home2V2.css';
import Navbar from '../About/Navbar';
import Hero from './Hero';
import Footer from '../About/Footer';
import UploadPopup from '../JD/UploadDialog';
import { useNavigate } from 'react-router-dom';
import JobsTable from './jdTable';
import CandidateFollowup from './Cc';
import JDModal from "../JD/JdModal";

function AllJob() {
    const navigate = useNavigate();
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const jobsContainerRef = useRef(null);
    const [jobsSectionHeight, setJobsSectionHeight] = useState(0);
    const [loading, setLoading] = useState(true);
    const [jobs, setJobs] = useState([]);
    const [showJDModal, setShowJDModal] = useState(false);

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const response = await fetch("/api/get_jd", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch JDs");
                }

                const data = await response.json();
                setJobs(data);
            } catch (error) {
                console.error("Error fetching jobs:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchJobs();
    }, []);

    useEffect(() => {
        if (!jobsContainerRef.current) return;

        // Set initial height
        setJobsSectionHeight(jobsContainerRef.current.offsetHeight);

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setJobsSectionHeight(entry.contentRect.height);
            }
        });

        resizeObserver.observe(jobsContainerRef.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [jobs]); // 👈 Now recalculates when jobs update

    // Extra recalculation after loading in case ResizeObserver misses it
    useEffect(() => {
        if (!loading && jobsContainerRef.current) {
            setTimeout(() => {
                setJobsSectionHeight(jobsContainerRef.current.offsetHeight);
            }, 100);
        }
    }, [loading]);

    const toggleDropdown = (e) => {
        e.stopPropagation();
        setShowDropdown(prev => !prev);
    };

    const handleOutsideClick = (e) => {
        if (!e.target.closest('.post-job-dropdown-v22')) {
            setShowDropdown(false);
        }
    };

    const handleCreateJD = () => {
        navigate('/jd');
        setShowDropdown(false);
    };

    const handleGenerateJD = () => {
        navigate('/jdai');
        setShowDropdown(false);
    };

    const handleUploadJD = () => {
        navigate('/uploadjd');
        setShowDropdown(false);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleJobSelect = (jobId) => {
        setSelectedJobId(jobId);
    };

    if (loading) {
        return (
            <div className="loader-container">
                <div className="spinner"></div>
            </div>
        );
    }

    return (
        <>
            <div className="page-container">
                <Navbar />
                <Hero />
                <div className="all-job-v2">
                    {/* <div className="header">
                        <h2 className="header-title">Manage Your Job Listings with Ease</h2>
                        <p className="header-description">
                            Monitor job postings, review applications, and take quick actions with a streamlined interface.
                        </p>
                    </div> */}
                    <div className="dashboard-container">
                        <section className="ddashboard">
                            <div className="jobs-container-v2" ref={jobsContainerRef}>
                                <div className="jobs-section-v2-trial">
                                    <div className="jobs-header-v2">
                                        <div className="jobs-filter-v2">
                                            <span className="filter-text-v2">All Jobs</span>
                                            <img
                                                className="filter-icon-v2"
                                                loading="lazy"
                                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/2921160c9100cfc9e9704213dae0ba0daecd34621dab47297f1e437d36bd0640?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
                                                alt=""
                                            />
                                        </div>

                                        <div className="post-job-dropdown-v22" onClick={(e) => e.stopPropagation()}>
                                            <button className="post-job-btn-v22" onClick={toggleDropdown}>
                                                Post Job ▾
                                            </button>

                                            {showDropdown && (
                                                <div className="dropdown-menu">
                                                    <button className="dropdown-item" onClick={() => setShowJDModal(true)}>
                                                        Generate JD with AI
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                        {showPopup && <UploadPopup onClose={handleClosePopup} onUpload={handleUploadJD} />}
                                    </div>

                                    <div>
                                        <JobsTable onJobSelect={handleJobSelect} />
                                    </div>
                                </div>
                            </div>
                            <div className="djobs-all-jobs">
                                <CandidateFollowup maxHeight={jobsSectionHeight} />
                            </div>
                        </section>
                    </div>
                </div>
                <JDModal isOpen={showJDModal} onClose={() => setShowJDModal(false)} />
                <Footer />
            </div>
        </>
    );
}

export default AllJob;
